<!-- 修改线上月票订单信息 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台修改线上月票订单信息",
                t_url: this.commonUrls.test + "editOnlineVipTicket",
                p_url: this.commonUrls.prod + "editOnlineVipTicket",
                precondition: "无",
                fitSystem: "云停车场，VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketId', info2: '是', info3: 'Long', info4: '月票订单id' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码（支持设置多车牌，逗号分割）' },
                        { info1: 'userName', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'remark1', info2: '是', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '是', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '是', info3: 'String', info4: '备注3' },
                        { info1: 'editBy', info2: '是', info3: 'String', info4: '修改人' },
                        { info1: 'editTime', info2: '是', info3: 'String', info4: '修改时间(yyyyMMddHHmmss)' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/editOnlineVipTicket.vue